var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInactiveUserIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_87964",
    "data-name": "Group 87964",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14977",
    "data-name": "Rectangle 14977",
    width: 27,
    height: 27,
    rx: 7,
    fill: "#ffe3e2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(7 5.72)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1545",
    "data-name": "Ellipse 1545",
    cx: 3.979,
    cy: 3.979,
    r: 3.979,
    transform: "translate(3.437)",
    fill: "#ff0935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106618",
    "data-name": "Path 106618",
    d: "M9.7,19.365a4.518,4.518,0,0,1,.055-6.217q-.532-.041-1.086-.042a10.767,10.767,0,0,0-5.853,1.5A3.1,3.1,0,0,0,1.25,17.085v1.049a1.23,1.23,0,0,0,1.23,1.23Z",
    transform: "translate(-1.25 -4.523)",
    fill: "#ff0935",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_14",
    "data-name": "Subtraction 14",
    d: "M3.8,7.6A3.8,3.8,0,1,1,7.6,3.8,3.8,3.8,0,0,1,3.8,7.6Zm-1.44-5.6A.382.382,0,0,0,2,2.36a.361.361,0,0,0,.111.255L3.294,3.8l-.682.682-.5.5A.359.359,0,0,0,2,5.244a.362.362,0,0,0,.619.252L3.8,4.311,4.988,5.5A.36.36,0,1,0,5.5,4.988L4.311,3.8,5.5,2.615A.359.359,0,0,0,5.242,2a.356.356,0,0,0-.254.1L3.8,3.294,2.615,2.107A.363.363,0,0,0,2.359,1.995Z",
    transform: "translate(7.958 7.963)",
    fill: "#ff0935"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveUserIcon);
export default __webpack_public_path__ + "static/media/inactive_user_icon.472fd55e.svg";
export { ForwardRef as ReactComponent };